export const isPathExternal = (path: string | undefined): boolean => {
  return path ? path.indexOf('http') === 0 || path.indexOf('mailto:') === 0 || path.indexOf('tel:') === 0 : false
}

/* Check whether array is of the specified type */
export const isArrayOfType = (arr, type) => {
  return (
    Array.isArray(arr) &&
    arr.every(item => {
      if (typeof type === 'string') {
        return typeof item === type
      } else {
        return item instanceof type
      }
    })
  )
}

export const removeTaskPrefix = input => {
  // Regular expression to match task prefixes. Consult tests to understand regex
  const prefixPattern = /^(Task\s*\d*\.\s*|Task\s*\d*[-:]?\s*|-?\d+\s*[-:]?\s*)/i

  // Replace the matched prefix with an empty string
  return input.replace(prefixPattern, '')
}

export const extractTasks = (text, completedTasks) => {
  return extractArray(text)
    .filter(realTasksFilter)
    .filter(task => !(completedTasks || []).includes(task))
    .map(removeTaskPrefix)
}

export const extractArray = inputStr => {
  // Match an outer array of strings (including nested arrays)
  const regex = /(\[(?:\s*(?:"(?:[^"\\]|\\.|\n)*"|'(?:[^'\\]|\\.|\n)*')\s*,?)+\s*\])/
  const match = inputStr.match(regex)

  if (match && match[0]) {
    try {
      // Parse the matched string to get the array
      return JSON.parse(match[0])
    } catch (error) {
      console.error('Error parsing the matched array:', error)
    }
  }

  console.warn('Error, could not extract array from inputString:', inputStr)
  return []
}

// Model will return tasks such as "No tasks added". We should filter these
export const realTasksFilter = input => {
  const noTaskRegex = /^No( (new|further|additional|extra|other))? tasks? (is )?(required|needed|added|created|inputted).*$/i
  const taskCompleteRegex = /^Task (complete|completed|finished|done|over|success).*/i
  const doNothingRegex = /^(\s*|Do nothing(\s.*)?)$/i

  return !noTaskRegex.test(input) && !taskCompleteRegex.test(input) && !doNothingRegex.test(input)
}
